export default __webpack_public_path__ + "static/media/LOGO_JTD_NEW.fee2cc13.png";